import React from "react";

interface PinnedShadowProps {
  isScrolled: boolean;
}

/**
 * Gradient shadow overlay that appears on the right edge of pinned columns
 * when the table is scrolled horizontally.
 */
const PinnedShadow: React.FC<PinnedShadowProps> = ({ isScrolled }) => (
  <div
    className="absolute top-0 bottom-0 -right-[6px] w-[6px] pointer-events-none transition-opacity duration-200"
    style={{
      opacity: isScrolled ? 1 : 0,
      background: "linear-gradient(to right, rgba(0,0,0,0.08), transparent)",
      zIndex: 30,
    }}
  />
);

export default React.memo(PinnedShadow);
